import { all, call, takeLatest, put, takeEvery } from 'redux-saga/effects';
import { notification } from 'antd';

import { changeCitiesSequence, changeCountriesSequence, getCities, getCountries } from 'api/dictionaries';
import {
  LOCATIONS_ACTION_TYPES,
  requestCountriesList,
  successCitiesList,
  successCountriesList,
} from 'store/actions/locations.actions';

function* loadCountriesFlow() {
  try {
    const { data } = yield call(getCountries);
    yield put(successCountriesList(data));
  } catch (e) {
    notification.error({
      description: e.message,
    });
  }
}

function* changeSequenceCountriesFlow({ payload }) {
  try {
    yield call(changeCountriesSequence, payload);
    yield put(requestCountriesList);
  } catch (e) {
    notification.error({
      description: e.message,
    });
  }
}

function* loadCitiesFlow({ payload }) {
  const { country_code, country_name } = payload;
  try {
    const { data } = yield call(getCities, { country: country_code });
    yield put(successCitiesList({ [country_name]: data }));
  } catch (e) {
    notification.error({
      description: e.message,
    })
  }
}

function* changeSequenceCitiesFlow({ payload }) {
  try {
    yield call(changeCitiesSequence, payload);
  } catch (e) {
    notification.error({
      description: e.message,
    })
  }
}

export default function* () {
  yield all([
    takeLatest(LOCATIONS_ACTION_TYPES.LOAD_COUNTRIES, loadCountriesFlow),
    takeLatest(LOCATIONS_ACTION_TYPES.CHANGE_COUNTRIES_SEQUENCE, changeSequenceCountriesFlow),
    takeEvery(LOCATIONS_ACTION_TYPES.LOAD_CITIES, loadCitiesFlow),
    takeLatest(LOCATIONS_ACTION_TYPES.CHANGE_CITIES_SEQUENCE, changeSequenceCitiesFlow),
  ]);
}